import MOptionCard from './MOptionCard.vue';

MOptionCard.install = (app) => {
  app.component('MOptionCard', MOptionCard);
};

export { MOptionCard };
